import React from "react";
import { FiAlertCircle } from "react-icons/fi";

/** Placeholder rows shown while a tool's list loads (keeps the layout from jumping). */
export const ToolsSkeleton = ({ rows = 5, label = "Loading" }) => (
  <div className="tools-table-card" aria-busy="true" aria-label={label}>
    <div className="tools-skeleton">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="tools-skeleton__row" />
      ))}
    </div>
  </div>
);

/** Compact error row with a Retry action. */
export const ToolsLoadError = ({ text, onRetry }) => (
  <div className="tools-load-error" role="alert">
    <FiAlertCircle aria-hidden="true" />
    <span className="tools-load-error__text">{text}</span>
    <button type="button" className="tools-btn tools-btn--sm tools-btn--secondary" onClick={onRetry}>
      Retry
    </button>
  </div>
);
